import React from 'react';

import { StyledSliderSkeleton } from './slider.style';
import { StyledSliderControlsSkeleton } from '../../molecules/slider-controls/sliderControls.style';

const SliderSkeleton = () => (
  <StyledSliderSkeleton>
    <div className="skeleton-wrapper">
      <span />
      <span />
      <span />
    </div>
    <StyledSliderControlsSkeleton />
  </StyledSliderSkeleton>
);

export default SliderSkeleton;
